import 'featherlight';
import Highlighter from '../util/Highlighter';

// eslint-disable-next-line
import FeatherlightGallery  from 'featherlight/src/featherlight.gallery';

export function datalayer() {
  const dataLayer = $('#datalayer');
  const dataContent = $('.data-content');
  let datalayerUrl;

  const getPageData = (url, searchValue) => {
    var data = {
      'action': 'getPageData',
      url,
    };

    datalayerUrl = url;

    $.ajax({
      type: 'POST',
      url: sanacorp.ajax_url,
      data: data,
      success: function (res) {
        //$('body').addClass('overflow-hidden');
        dataLayer.addClass('opened');
        dataContent.html(res);
        initJsForHtml(searchValue);
      },
      error: function (request, status, error) {
        console.log(request);
        console.log(status);
        console.log(error);
      },
    });
  }

  $('a[data-layer="true"], a[href*="#data-layer"]').click(function (e) {
    e.preventDefault();
    var url = $(this).attr('href');
    var searchValue = $(this).data('search');
    getPageData(url, searchValue);
  });

  $('.slider').on('click', 'a[data-layer="true"]', function (e) {
    e.preventDefault();
    var url = $(this).attr('href');
    getPageData(url);
  });

  const close = () => {
    $('body').removeClass('overflow-hidden');
    dataContent.addClass('close-anim');

    setTimeout(() => {
      dataContent.removeClass('close-anim').scrollTop(0);
      dataLayer.removeClass('opened');
    }, 500)
  }

  $('.btn-close').click(function (e) {
    e.preventDefault();
    close();
  });

  dataLayer.click(function (e) {
    if (e.target.id === 'datalayer') {
      close();
    }
  });

  function initJsForHtml(searchValue) {
    var video = Array.from(dataContent.find('.plyr-video'));
    // eslint-disable-next-line
    video.map(p => new Plyr(p, {
        controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
      })
    );

    // gallery
    var loadMoreButton = dataContent.find('.gallery button');
    var galleryList = dataContent.find('.gallery .card-columns');
    reinitFeatherlightGallery();

    const data = {
      'action': 'galleryShowMore',
      'show': sanacorp.gallery_show_count,
      'offset': sanacorp.gallery_show_count,
      'datalayerUrl': datalayerUrl,
    };

    const loadMore = () => {
      $.ajax({
        type: 'POST',
        url: sanacorp.ajax_url,
        data: data,
        dataType: 'json',
        success: function (res) {
          galleryList.append(res['content']);
          data.offset = res['offset'];
          if (res['more'] == 0) loadMoreButton.removeClass('d-block').css('display', 'none');

          reinitFeatherlightGallery();
        },
        error: function (request, status, error) {
          console.log(request);
          console.log(status);
          console.log(error);
        },
      });
    }

    loadMoreButton.click(function () {
      loadMore();
    });

    var highlight = new Highlighter('datalayer');
    highlight.setMatchType('open');
    highlight.apply(searchValue);
  }

  function reinitFeatherlightGallery() {
    dataContent.find('.gallery a').featherlightGallery({
      type: 'image',
      previousIcon: '',
      nextIcon: '',
      closeIcon: '',
      onResize: function () {
        this.$instance.find('.caption').width(this.$content.width() - 30)
      },
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/components/datalayer.js